<div class="generalPage" aria-label="help feedback" role="main">
  <div class="pr-22 content-container pb-0 print-all-content">
        <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{fb_header}}</h1>
        <p class="answer font-16 content-blue width-100" [innerHTML]="fb_desc"></p>
        <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{fb_para1header}}</p>
        <p class="answer font-16 content-blue width-100" (click)="openlinkById($event)" [innerHTML]="fb_para1body"></p>
        <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{fb_para2header}}</p>
        <p class="answer font-16 content-blue width-100 pb-heading" (click)="openFeedback($event)" [innerHTML]="fb_para2body"></p>
      </div>
    </div>


